import { render, staticRenderFns } from "./FormFileType.vue?vue&type=template&id=5503488e"
import script from "./FormFileType.vue?vue&type=script&lang=js"
export * from "./FormFileType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports